module.exports = __webpack_public_path__ + "static/media/post-sleep.e294faae.svg";